import styled from '@emotion/styled';

export const TableTopItemContainer = styled.div`
  margin-top: -20px;
`;
